const GalleryImgs = ({ imageGenre, rowsPerColumn, setRowsPerColumn, maxRowsPerColumn, setMaxRowsPerColumn }) => {
	setMaxRowsPerColumn(imageGenre === "Quds008" ? Math.floor(parseInt(imageGenre.slice(-3)) / 3) : Math.ceil(parseInt(imageGenre.slice(-3)) / 3));

	const images = {
		General108: [],
		AlAqsa021: [],
		Car011: [],
		Quds008: [],
		Nature030: [],
		Portrait010: [],
		ChildrenOfAlAqsa028: [],
	};

	for (let k in images) {
		if (k === "General108") continue;
		const numberOfImages = k.slice(-2);
		for (let i = 1; i <= numberOfImages; i++) {
			images["General108"].push(`./assets/${k.substring(0, k.length - 3)}/${k.substring(0, k.length - 3)}-${i}.jpg`);
			images[k].push(`./assets/${k.substring(0, k.length - 3)}/${k.substring(0, k.length - 3)}-${i}.jpg`);
		}
	}
	const columnCount = 3;

	function setMaxRows() {
		setMaxRowsPerColumn(Math.ceil(parseInt(imageGenre.slice(-3)) / columnCount));
	}

	function handleLoadMore() {
		setMaxRows();
		while (maxRowsPerColumn >= rowsPerColumn) {
			setRowsPerColumn(rowsPerColumn + 1);
			return;
		}
		console.log(`Setting rows to max`);
		setRowsPerColumn(imageGenre === "Quds008" ? Math.floor(parseInt(imageGenre.slice(-3)) / 3) : Math.ceil(parseInt(imageGenre.slice(-3)) / 3));
	}

	const columns = [];
	for (let i = 0; i < columnCount; i++) {
		const start = i * rowsPerColumn;
		const end = start + rowsPerColumn;
		const columnImages = images[imageGenre].slice(start, end);
		columns.push(columnImages);
	}

	const getRandomImage = (imageArray) => {
		const randomIndex = Math.floor(Math.random() * imageArray.length);
		const randomImage = imageArray[randomIndex];
		imageArray.splice(randomIndex, 1);
		return randomImage;
	};

	function handleFocusImage(e) {
		const image = e.target;
		const overlay = document.querySelector(".overlay");

		overlay.classList.toggle("hidden");
		image.classList.toggle("hover:brightness-50");
		image.classList.toggle("focus");

		if (overlay.classList.contains("hidden")) {
			document.body.style.overflow = "auto";
		} else {
			document.body.style.overflow = "hidden";
			overlay.addEventListener("click", () => {
				overlay.classList.add("hidden");
				image.classList.add("hover:brightness-50");
				image.classList.remove("focus");
				document.body.style.overflow = "auto";
				image.style.left = "0";
			});
		}

		if (image.offsetWidth > image.offsetHeight) {
			image.style.left = "30%";
		} else {
			image.style.left = "40%";
		}
	}

	return (
		<section id="gallery" dir="ltr" className="relative grid grid-cols-3 gap-x-[4px] my-8 mt-16 lg:gap-x-[8px] lg:mx-44">
			<div className="overlay hidden"></div>
			{columns.map((column, columnIndex) => (
				<div key={columnIndex} className={`flex flex-col gap-y-[4px] overflow-hidden lg:gap-y-[8px]`}>
					{column.map((image, index) =>
						imageGenre === "General108" ? (
							<img
								loading="lazy"
								className={"hover:brightness-50 object-contain"}
								onClick={handleFocusImage}
								key={index}
								src={getRandomImage(images["General108"])}
								alt=""
							/>
						) : (
							<img
								loading="lazy"
								className={"hover:brightness-50 object-contain"}
								onClick={handleFocusImage}
								key={index}
								src={image}
								alt=""
							/>
						)
					)}
				</div>
			))}
			<button
				onClick={handleLoadMore}
				on
				className={
					maxRowsPerColumn <= rowsPerColumn
						? `hidden btn-shadow bg-lightBrown border-4 border-lightBrown rounded-3xl w-fit my-8 px-8 text-3xl font-bold place-self-center col-span-full`
						: `btn-shadow bg-lightBrown border-4 border-lightBrown rounded-3xl w-fit my-8 px-8 text-3xl font-bold place-self-center col-span-full`
				}
			>
				المزيد
			</button>
		</section>
	);
};

export default GalleryImgs;
